'use client';

import { motion, useReducedMotion } from 'motion/react';

import { TrackedAnchor } from '@/components/ancher';
import { TRACKED_EVENT_POSITION } from '@/constants';
import { cn } from '@lib/utils';

import { HERO_SCROLL_TARGET } from './hero.constants';

// hero 하단 스크롤 인디케이터.
// - 위아래 5px 바운스(장식) — reduced-motion 시 정지 (WCAG 2.3.3)
// - 클릭 시 '자세히 보기' CTA와 동일하게 #solution 영역으로 이동
export function HeroScrollIndicator({ ariaLabel }: { ariaLabel: string }) {
  const reduceMotion = useReducedMotion();

  return (
    <TrackedAnchor
      href={HERO_SCROLL_TARGET}
      label="hero_scroll-indicator"
      position={TRACKED_EVENT_POSITION.MAIN_HEADER}
      aria-label={ariaLabel}
      className={cn(
        'absolute bottom-[30px] left-1/2 -translate-x-1/2 md:bottom-[73px]',
        'inline-flex items-center justify-center rounded-full',
        'ring-offset-background focus-visible:ring-ring focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
      )}
    >
      {/* 성능상 SVG 대신 래퍼 div를 애니메이트한다 */}
      <motion.div
        animate={reduceMotion ? undefined : { y: [0, 10, 0] }}
        transition={
          reduceMotion
            ? undefined
            : { duration: 1.4, repeat: Infinity, ease: 'easeInOut' }
        }
      >
        <svg
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="h-8 w-8 md:h-10 md:w-10"
          aria-hidden="true"
        >
          <path
            d="M35.5314 11.5276C36.3124 12.3086 36.3124 13.5746 35.5314 14.3557L21.4142 28.4738C20.6332 29.2547 19.3661 29.2548 18.5851 28.4738L4.46796 14.3557C3.68696 13.5747 3.68707 12.3086 4.46796 11.5276C5.249 10.7465 6.51503 10.7465 7.29608 11.5276L19.9992 24.2297L32.7033 11.5276C33.4844 10.7465 34.7504 10.7465 35.5314 11.5276Z"
            fill="white"
          />
        </svg>
      </motion.div>
    </TrackedAnchor>
  );
}
